<template>
    <div>
        <b-col class="d-flex justify-content-center" style="flex-grow: 0;">
            <div @click="expandSearchDetail" class="toggle-line" :class="{ 'open': isFilterExpanded }">
                <span>Search Detail</span>
            </div>
        </b-col>
        <b-collapse v-model="isFilterExpanded">
            <b-row class="wbs-filter">
                <b-col cols="3" class="filter-step">
                    <div class="filter-input-wrapper">
                        <label class="filter-input-label" for="filter-l1">L1</label>
                        <select id="filter-l1" class="custom-select" v-model="filter.l1">
                            <option v-for="option in l1Options" :key="option.value" :value="option"> {{ option.text }} </option>
                        </select>
                    </div>
                    <div class="filter-input-wrapper">
                        <label class="filter-input-label" for="filter-l2">L2</label>
                        <select id="filter-l2" class="custom-select" v-model="filter.l2" :disabled="!filter.l1.value">
                            <option v-for="option in l2Options" :key="option.value" :value="option"> {{ option.text }} </option>
                        </select>
                    </div>
                    <div class="filter-input-wrapper">
                        <label class="filter-input-label" for="filter-l3">L3</label>
                        <select id="filter-l3" class="custom-select" v-model="filter.l3" :disabled="!filter.l2.value">
                            <option v-for="option in l3Options" :key="option.value" :value="option"> {{ option.text }} </option>
                        </select>
                    </div>
                </b-col>
                <b-col cols="8" class="filter-detail">
                    <b-row>
                        <b-col cols="6">
                            <div class="filter-input-wrapper">
                                <label class="filter-input-label">Status</label>
                                <b-form-select id="filter-status" class="custom-select" v-model="filter.status" :options="statusOptions">
                                </b-form-select>
                            </div>
                        </b-col>    
                        <b-col cols="6">
                            <div class="filter-input-wrapper">
                                <label class="filter-input-label">Assignee</label>
                                <b-form-select id="l3" class="custom-select" v-model="filter.assignee" :options="assigneeOptions">
                                </b-form-select>
                            </div>
                        </b-col>    
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <div class="filter-input-wrapper">                            
                                <label class="filter-input-label">Duration</label>
                                <b-form-input id="start-date" name="start-date" type="date" v-model="filter.startDate"
                                    class="custom-input" placeholder="YYYY-MM-DD"></b-form-input>
                                <span class="tilde">&#126;</span>
                                <b-form-input id="due-date" name="due-date" type="date" v-model="filter.dueDate"
                                    class="custom-input" data-vv-as="due date" placeholder="YYYY-MM-DD"></b-form-input>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="filter-input-wrapper">                            
                                <label for="keyword" class="filter-input-label">Keyword</label>
                                <b-form-input id="keyword" name="keyword" type="text" v-model="filter.keyword"
                                    class="custom-input" @keyup.enter="handleSearchClick" placeholder="Title, Status, Start Date, Due Date, Assignee"></b-form-input>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="1" style="padding: 0;">
                    <div class="filter-button-area">
                        <button @click="handleSearchClick" class="search-button">Search</button>
                        <button @click="handleResetClick" class="reset-button">Reset</button>                    
                    </div>
                </b-col>
            </b-row>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: "WbsFilter",
    props: {
        projectId : {type:String},
        devMethodologyList: {type:Array},
    },
    watch: {
        projectId: {
            immediate: false,
            handler() {
                // 프로젝트가 바뀌면 필터 리셋
                this.$store.commit('wbs/resetFilter');

                // l1 기본값 넣기
                this.filter.l1 = this.l1Options[0];
            }
        }
    },
    created() {
        // 필터 컴포넌트 생성 시
        // vuex에 필터가 비어있으면
        if(this.isFilterEmpty) {
            // l1 기본값 넣기
            this.filter.l1 = this.l1Options[0];   
        } else {
            this.emitSearchWbs();
        }
    },
    computed: {
        isFilterExpanded: {
            get() {
                return this.$store.getters['wbs/getFilterExpanded'];
            },
            set(value) {
                this.$store.commit('wbs/setFilterExpanded', value);
            }
        },
        l1Options() {
            const l1Options = this.devMethodologyList.map(devMethodology => ({
                value: devMethodology.step,
                text: devMethodology.step,
                children: devMethodology.children
            }))
            
            const allL1 = { value: "", text: "All", children: []}
            return [allL1, ...l1Options];
        },
        l2Options() {
            const allL2 = { value: "", text: "All", children: []}
            if(!this.filter.l1.value) {
                this.filter.l2 = allL2;
                return [];
            }

            const l2Options = this.filter.l1.children.map(devMethodology => ({
                value: devMethodology.step,
                text: devMethodology.step,
                children: devMethodology.children
            }))

            return [allL2, ...l2Options];
        },
        l3Options() {
            const allL3 = { value: "", text: "All", children: []}
            if(!this.filter.l2.value) {
                this.filter.l3 = allL3;
                return [];
            }
            const l3Options = this.filter.l2.children.map(devMethodology => ({
                value: devMethodology.step,
                text: devMethodology.step,
                children: devMethodology.children
            }))
            return [allL3, ...l3Options];
        },
        statusOptions() {
            let optionsObj = this.$store.getters['chatter/options']['statusOptions'];
            let allOption = { value: "", text: "All Status" };
            return [allOption, ...optionsObj];
        },
        assigneeOptions() {
            let memberList = this.$store.getters['chatter/getAllProjectInfo']
                .filter(obj => obj.projectId === this.projectId)[0]
            if (memberList) {
                memberList = memberList.projectUserList.map(item => ({
                    value: item.userId,
                    text: item.userName
                })).slice().sort((a, b) => {
                    return a.text.localeCompare(b.text);
                })
            } else {
                memberList = [];
            }

            let allAssignee = {value: "", text: "All Assignee"};
            return [allAssignee, ...memberList];
        },
        filter() {
            return this.$store.getters['wbs/getFilter'];
        },
        isFilterEmpty() {
            const l1 = this.filter.l1.value === undefined ? '' : this.filter.l1.value;
            const l2 = this.filter.l2.value === undefined ? '' : this.filter.l2.value;
            const l3 = this.filter.l3.value === undefined ? '' : this.filter.l3.value;


            if(l1 != '') {
                return false;
            }
            if(l2 != '') {
                return false;
            }
            if(l3 != '') {
                return false;
            }
            if(this.filter.status != '') {
                return false;
            }
            if(this.filter.assignee != '') {
                return false;
            }
            if(this.filter.startDate != '') {
                return false;
            }
            if(this.filter.dueDate != '') {
                return false;
            } 

            if(this.filter.keyword.trim() != '') {
                return false;
            }

            return true;
        },
    },
    methods: {
        handleSearchClick() {
            this.$store.commit('wbs/resetExpanded');
            this.emitSearchWbs();
        },
        emitSearchWbs() {
            if(this.filter.startDate != '' && !this.isValidDateFormat(this.filter.startDate)) {
                this.showMessage("Duration - Start Date의 형식이 올바르지 않습니다.");
                return
            }

            if(this.filter.dueDate != '' && !this.isValidDateFormat(this.filter.dueDate)) {
                this.showMessage("Duration - Due Date의 형식이 올바르지 않습니다.");
                return
            }
            
            const searchFilter = {
                l1: this.filter.l1.value,
                l2: this.filter.l2.value,
                l3: this.filter.l3.value,
                status: this.filter.status,
                assignee: this.filter.assignee,
                startDate: this.filter.startDate,
                dueDate: this.filter.dueDate,
                keyword: this.filter.keyword.trim()
            }

            this.$emit("searchWbs", searchFilter);
        },
        handleResetClick() {
            this.$store.commit('wbs/resetFilter');
            this.filter.l1 = this.l1Options[0];
        
            const emptyFilter = {
                l1: '',
                l2: '',
                l3: '',
                status: '',
                assignee: '',
                startDate: '',
                dueDate: '',
            }

            this.$emit("resetWbs", emptyFilter);
        },
        isValidDateFormat(dateStr) {
            const regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
            return regex.test(dateStr);
        },
        
        expandSearchDetail() {
            this.isFilterExpanded = !this.isFilterExpanded;
        },

        showMessage(message) {
            this.$bvToast.toast(message, {
              title: `Notification`,
              toaster: "b-toaster-bottom-center",
              solid: true,
              appendToast: false,
              autoHideDelay: 4000,
              variant: "danger"
            });
        },
    }
}
</script>

<style scoped>
/* .wbs-filter {
    padding-bottom: 1em;
    border-bottom: 1px solid #E7E7EE;
    margin-bottom: 1em;
} */

.toggle-line {
  position: relative;
  display: block;
  width: 100%;
  margin: 10px 0;
  text-align: center;
}

.toggle-line::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #DDDDE3;
  transform: translateY(-50%);
}

.toggle-line span {
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 8px 30px 8px 34px;
  background-color: #fff;
  color: #747480;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
}

.toggle-line span::after {
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 12px;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.166 6L8.49935 10.6667L3.83268 6' stroke='%23747480' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.toggle-line.open span::after {
  transform: rotate(180deg);
}
.filter-input-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}
.filter-input-wrapper label {
    margin-bottom: 0px;
    margin-right: 0.5rem;
}

.custom-select {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.custom-input {
  /* padding: 0.533rem 2.266rem 0.533rem 1.066rem; */
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  margin: 0px;
}

.filter-step {
    border-right: 1px solid #E7E7EE;
}

.filter-input-label {
    min-width: 5rem;
}
.tilde {
    margin: 0 0.4em;
}

.filter-button-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100%;
    padding-right: 2em;
}


.filter-button-area .search-button {
    border:none;
    background-color: rgb(46, 46, 56);
    color: #FFE305;
    font-weight: bold;
    border-radius: 10px;
    width: 100%;
    height: 50%;
}

.filter-button-area .search-button:disabled {
    background-color: #F0F0F0;
    
}

.filter-button-area .reset-button {
    border: none;
    background-color: #d9d9db;
    border-radius: 10px;
    width: 100%;
}


</style>